import { CellContext } from '@tanstack/react-table';
import { Button, lucideIcons, Popover } from '@round/creatorbase-ui';
import AddCreatorToCampaignsDropdown from 'Modules/Plans/CreatorSearch/components/AddCreatorToCampaignsDropdown/AddCreatorToCampaignsDropdown';
import { CreatorAccountRow, getMeta } from '../../helpers';
import styles from './ActionsCell.module.css';

const { Megaphone } = lucideIcons;

const ADD_TO_CAMPAIGN_LABEL = 'Add to campaign';

type Props = CellContext<CreatorAccountRow, unknown>;

export const ActionsCell = ({ row: { original }, table }: Props) => {
    const { isExploreLoading } = getMeta(table);

    // Only a saved account can be put on a campaign, and a row without one has nothing to offer.
    if (original.client_influencer_account_id === null) {
        return null;
    }

    const { exploreAccount } = original;

    return (
        <AddCreatorToCampaignsDropdown
            accountId={original.client_influencer_account_id}
            // The account's rate comes from Creator Explore as `rate`, so there is no saved one to read.
            clientInfluencer={null}
            rate={exploreAccount ? { cost: exploreAccount.cost, currencyId: exploreAccount.currency_id } : null}
            platform={original.platform}
            // Adding to a campaign is the only thing a row offers, so the button opens the picker
            // itself rather than hanging off a menu.
            trigger={
                <Popover.Trigger asChild>
                    {/* Held back until the rate is in: the post form reseeds its cost whenever the rate
                        changes, so one landing after the picker opened would wipe a cost typed by then. */}
                    <Button variant="outline" size="xs" className={styles.trigger} disabled={isExploreLoading}>
                        <Megaphone className={styles.icon} aria-hidden="true" />
                        {ADD_TO_CAMPAIGN_LABEL}
                    </Button>
                </Popover.Trigger>
            }
        />
    );
};
